<template lang="html">
    <div class="d-flex flex-column h-100 position-relative">

        <div class="navigator" style="height: 65px;">
            <h2 class="mr-auto">Promocodes</h2>

            <div>
                <span class="mr-3 color-6 pointer" @click="deleteBtn">Delete</span>

                <button class="btn blue wide mr-3" @click="cancelBtn">
                    Cancel
                </button>

                <button class="btn secondary wide mr-3" @click="pauseBtn" :class="{'disabled': isPromocodeInvalid}">
                    Pause
                </button>

                <button class="btn wide mr-3" @click="saveBtn" :class="{'disabled': isPromocodeInvalid}">
                    Save
                </button>

                <button class="btn wide mr-3" @click="publishBtn" :class="{'disabled': isPromocodeInvalid}">
                    Publish
                </button>

                <button class="btn wide blue" @click="pressSeeAffectedEvents">
                    Preview list of events
                </button>
            </div>
        </div>

        <!-- white area -->
        <div class="px-3 py-4 d-flex flexGrow1 overflow-auto">
            <div class="col-sm-12 bg-lightest">
                <promocode-form v-if="promocode && promocode.id" :promocode="promocode" @change="promocodeChanged"></promocode-form>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import PromocodeForm from './components/promocodeForm'
export default {
    data: function () {
        return {
            promocode: null,
            isPromocodeInvalid: false,
            promocodeValidation: null
        }
    },
    beforeCreate: function () {

    },
    created: function () {
        // prevents access to url directly without a selected promocode
        if(!this.getSelectedPromocode || !this.getSelectedPromocode.id){
            this.$router.push({name:'promocodes'})
        } else {
            this.promocode = this.getSelectedPromocode
        }
    },
    computed: {
        ...mapGetters([
            'getSelectedPromocode',
        ]),
    },
    methods: {
        ...mapActions([
            'updatePromocode',
            'updatePromocodeActive',
            'updatePromocodePause',
            'deletePromocode',
            'openModal',
        ]),
        deleteBtn: function () {
            this.deletePromocode(this.promocode).then(response => {
                this.$router.push({name:'promocodes'})
            })
        },
        cancelBtn: function () {
            this.$router.push({name:'promocodes'})
        },
        pauseBtn: function () {
            if(!this.isPromocodeInvalid){
                this.updatePromocodePause(this.promocode).then(response => {
                    this.$router.push({name:'promocodes'})
                })
            } else {
                this.promocodeValidation.promocode.$touch()
            }
        },
        saveBtn: function () {
            if(!this.isPromocodeInvalid){
                this.updatePromocode(this.promocode).then(response => {
                    this.$router.push({name:'promocodes'})
                })
            } else {
                this.promocodeValidation.promocode.$touch()
            }
        },
        publishBtn: function () {
            if(!this.isPromocodeInvalid){
                this.updatePromocodeActive(this.promocode).then(response => {
                    this.$router.push({name:'promocodes'})
                })
            } else {
                this.promocodeValidation.promocode.$touch()
            }
        },
        promocodeChanged: function (e) {
            this.isPromocodeInvalid = e.v.promocode.$invalid
            this.promocodeValidation = e.v
        },
        pressSeeAffectedEvents: function () {
            this.openModal('PromocodeAffectedEvents')
        }
    },
    components: {
        PromocodeForm
    },
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// promocodeEdit.vue?44c96b85